/**
 * CR-7732: the Haulier picker — used by New / Edit Call-off and by the
 * Change haulier control on the call-off detail.
 */
import type { HaulierOption } from '../../../lib/api';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';

/** Radix Select items can't carry an empty value, so "none" stands in for null. */
const NO_HAULIER = 'none';

interface CallOffHaulierSelectProps {
  options: HaulierOption[];
  /** The selected haulier's company id, or null for none. */
  value: number | null;
  onChange: (haulierId: number | null) => void;
  disabled?: boolean;
  loading?: boolean;
}

export default function CallOffHaulierSelect({
  options, value, onChange, disabled = false, loading = false,
}: CallOffHaulierSelectProps) {
  return (
    <Select
      value={value === null ? NO_HAULIER : String(value)}
      onValueChange={(v) => onChange(v === NO_HAULIER ? null : Number(v))}
      disabled={disabled || loading}
    >
      <SelectTrigger aria-label="Haulier">
        <SelectValue placeholder={loading ? 'Loading hauliers…' : 'Select haulier'} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NO_HAULIER}>No haulier</SelectItem>
        {options.map(option => (
          <SelectItem key={option.id} value={String(option.id)}>
            {option.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
